module.exports = __webpack_public_path__ + "static/media/1026143.64235755.jpg";